import React, { Suspense, useEffect } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import FreeAuthRoute from "./routes/FreeAuthRoute";
import PageNotFound from "./pages/PageNotFound";
import { routerData } from "./config/RoutesConfig";
import FrontLayout from "./layouts/front/FrontLayout";
import AdminLayout from "./layouts/auth/AdminLayout";
import UserRoute from "./routes/UserRoute";
import AdminRoute from "./routes/AdminRoute";
import BlankLayout from "./layouts/BlankLayout";
import AuthRoute from "./routes/AuthRoute";
import LoadingFallback from "./components/elements/LoadingFallback";
import AdminNotAllowRoute from "./routes/AdminNotAllowRoute";
import { useSelector } from "react-redux";
import DonorRoute from "./routes/DonorRoute";
import UserLayout from "./layouts/user/UserLayout";

import Home from "./pages/Home";
import BillPay from "./pages/user/BillPay";
import Menu from "./pages/user/Menu";
import MenuDetails from "./pages/user/MenuDetails";
import PaymentSucces from "./pages/user/PaymentSucces";
import { useOrganizationConfig } from "./hooks/useOrganizationConfig";
import DynamicBistroRoute from "./components/DynamicBistroRoute";

const CreateRoutes = () => {
  const { session } = useSelector((state) => state?.authProvider);
  const { config, loading } = useOrganizationConfig();

  if (loading) {
    return <LoadingFallback />;
  }

  const bistroSlug = config?.slug || 'bistro';

  return (
    <Suspense fallback={<LoadingFallback />}>
      <ScrollToTop>
        <Routes>
          {(
            routerData({
              user: session?.user,
            }) || []
          )
            ?.filter((item) => !item?.disabled || item?.disabled === undefined)
            ?.map((route, i) => {
              let Layout = React.Fragment;

              if (route.layout === "front") {
                Layout = FrontLayout;
              } else if (route.layout === "user") {
                Layout = UserLayout;
              } else if (route.layout === "admin") {
                Layout = AdminLayout;
              } else if (!route.layout) {
                Layout = BlankLayout;
              }

              return (
                <Route
                  key={route?.key || i}
                  path={route.path}
                  element={
                    route?.routeType === "admin" ? (
                      <AdminRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </AdminRoute>
                    ) : route?.routeType === "auth" ? (
                      <AuthRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </AuthRoute>
                    ):(
                      <UserRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </UserRoute>
                    )
                    //  : route?.routeType === "user" ? (
                    //   <UserRoute>
                    //     <Layout metaTitle={route?.title || ""} />
                    //   </UserRoute>
                    // )
                    // : route?.routeType === "auth" ? (
                    //   <AuthRoute>
                    //     <Layout metaTitle={route?.title || ""} />
                    //   </AuthRoute>
                    // ) : route?.routeType === "adminNotAllow" ? (
                    //   <AdminNotAllowRoute>
                    //     <Layout metaTitle={route?.title || ""} />
                    //   </AdminNotAllowRoute>
                    // ) : (
                    //   <FreeAuthRoute>
                    //     <Layout metaTitle={route?.title || ""} />
                    //   </FreeAuthRoute>
                    // )
                  }
                >
                  <Route path={route?.path} exact element={<route.component />} />
                  {route?.subRoute?.map((sub, j) => (
                    <Route key={j?.toString()} path={sub?.path} exact element={<sub.component />} />
                  ))}
                </Route>
              );
            })}
          
          {/* Root redirect to dynamic bistro home */}
          <Route 
            path="/" 
            element={<Navigate to={`/${bistroSlug}/home`} replace />} 
          />

          {/* Dynamic Bistro Routes - Using :orgSlug wildcard */}
          <Route path="/:orgSlug/home" element={
            <DynamicBistroRoute>
              <Home />
            </DynamicBistroRoute>
          } />

          <Route path="/:orgSlug/home/table/:table" element={
            <DynamicBistroRoute>
              <Home />
            </DynamicBistroRoute>
          } />

          <Route path="/:orgSlug/paybill/table/:table" element={
            <DynamicBistroRoute>
              <BillPay />
            </DynamicBistroRoute>
          } />

          <Route path="/:orgSlug/paybill/table/:table/:orderid" element={
            <DynamicBistroRoute>
              <BillPay />
            </DynamicBistroRoute>
          } />

          <Route path="/:orgSlug/menu" element={
            <DynamicBistroRoute>
              <Menu />
            </DynamicBistroRoute>
          } />

          <Route path="/:orgSlug/menu/table/:table" element={
            <DynamicBistroRoute>
              <Menu />
            </DynamicBistroRoute>
          } />

          <Route path="/:orgSlug/menu-details/:slug" element={
            <DynamicBistroRoute>
              <MenuDetails />
            </DynamicBistroRoute>
          } />

          <Route path="/:orgSlug/menu-details/:slug/:table" element={
            <DynamicBistroRoute>
              <MenuDetails />
            </DynamicBistroRoute>
          } />

          <Route path="/:orgSlug/payment-success" element={
            <DynamicBistroRoute>
              <PaymentSucces />
            </DynamicBistroRoute>
          } />

          <Route path="/:orgSlug/payment-success/table/:table" element={
            <DynamicBistroRoute>
              <PaymentSucces />
            </DynamicBistroRoute>
          } />

          {/* 404 Page */}
          <Route path="*" element={<PageNotFound />} />

          {/* <Route path="/" element={<Home />} />
          <Route path="/bistro/home" element={<Home />} />
          <Route path="/bistro/home/table/:table" element={<Home />} />
          <Route path="/bistro/paybill/table/:table" element={<BillPay />} />
          <Route path="/bistro/paybill/table/:table/:orderid" element={<BillPay />} />
          <Route path="/bistro/menu" element={<Menu />} />
          <Route path="/bistro/menu/table/:table" element={<Menu />} />
          <Route path="/bistro/menu-details/:slug" element={<MenuDetails />} />
          <Route path="/bistro/menu-details/:slug/:table" element={<MenuDetails />} />
          <Route path="/bistro/payment-success" element={<PaymentSucces />} />
          <Route path="/bistro/payment-success/table/:table" element={<PaymentSucces />} /> */}
        </Routes>
      </ScrollToTop>
    </Suspense>
  );
};

export default CreateRoutes;
